import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'impact-level';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Impact level',
};

const sstImpactLevel = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstImpactLevel };
